import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useOrganizationUIContext } from "../../OrganizationUIContext";
import { initialFilter } from "../../OrganizationUIHelpers";
import ReactSelect, { components } from "react-select";
import {
  IS_ACTIVE,
  IS_EXPIRED,
  ORGANIZATION_STATUS_OPTION
} from "../../../../../../config/helper";
import { findAllOrgRegional } from "../../../../_redux/organization-regional/organizationRegionalCrud";
import { useSelector } from "react-redux";
import { findOrganizationCategory } from "../../../../_redux/organization-category/organizationCategoryCrud";
import { genOptionLoaderDebounced } from "../../../../../../../_metronic/_helpers/fetchUtils";
import AsyikSelect from "react-select/async";

const prepareFilter = (queryParams, values) => {
  const {
    name,
    status,
    is_activated,
    is_expired,
    organization_regional_uuid,
    organization_category_uuid
  } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  filter.status = status ?? "";
  filter.is_activated = is_activated ?? "";
  filter.is_expired = is_expired ?? "";
  filter.organization_regional_uuid = organization_regional_uuid ?? "";
  filter.organization_category_uuid = organization_category_uuid ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const OrganizationFilter = ({ listLoading }) => {
  // Organization UI Context
  const organizationUIContext = useOrganizationUIContext();
  const organizationUIProps = useMemo(() => {
    return {
      setQueryParams: organizationUIContext.setQueryParams,
      queryParams: organizationUIContext.queryParams,
      filterType: organizationUIContext.filterType
    };
  }, [organizationUIContext]);

  const { user } = useSelector(state => state.auth);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(
      organizationUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, organizationUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      organizationUIProps.setQueryParams(newQueryParams);
    }
  };

  const [options, setOptions] = useState({
    orgRegional: [],
    orgCategory: []
  });

  useEffect(() => {
    findOptions();
  }, []);

  const findOptions = async () => {
    const {
      data: { data: regionalData }
    } = await findAllOrgRegional();

    const {
      data: { data: categoryData }
    } = await findOrganizationCategory({
      pageNumber: 1,
      pageSize: 10,
      filter: {}
    });

    setOptions(prev => ({
      ...prev,
      orgRegional: regionalData,
      orgCategory: categoryData.items
    }));

    console.log(`categoryData`, categoryData);
  };

  return (
    <Formik
      initialValues={initialFilter.filter}
      enableReinitialize
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <label htmlFor="name">Nama</label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Nama Lembaga..."
                onBlur={handleBlur}
                value={values.name}
                onChange={e => {
                  setFieldValue("name", e.target.value);
                }}
              />
            </div>
            {/* <div className="col-lg-4">
              <label htmlFor="status">Status</label>
              <ReactSelect
                name="status"
                options={ORGANIZATION_STATUS_OPTION.map(item => ({
                  label: item.label,
                  value: item.value
                }))}
                value={
                  values.status
                    ? {
                        label: values.status,
                        value: values.status
                      }
                    : null
                }
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("status", value);
                  } else {
                    setFieldValue("status", null);
                  }
                }}
              />
            </div> */}
            <div className="col-lg-4">
              <label htmlFor="is_activated">Status Aktif</label>
              <ReactSelect
                name="is_activated"
                options={IS_ACTIVE.map(item => ({
                  label: item.label,
                  value: item.value
                }))}
                placeholder="Pilih Status Aktif..."
                value={{
                  label: values.is_activated_label,
                  value: values.is_activated
                }}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  const label = e && e.label;
                  setFieldValue("is_activated_label", label);
                  setFieldValue("is_activated", value);
                  // if (value) {
                  // } else {
                  //   setFieldValue("is_activated", false);
                  // }
                }}
              />
            </div>
            <div className="col-lg-4">
              <label htmlFor="is_expired">Status Expired</label>
              <ReactSelect
                name="is_expired"
                options={IS_EXPIRED.map(item => ({
                  label: item.label,
                  value: item.value
                }))}
                placeholder="Pilih Status Expire..."
                value={{
                  label: values.is_expired_label,
                  value: values.is_expired
                }}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  const label = e && e.label;
                  setFieldValue("is_expired_label", label);
                  setFieldValue("is_expired", value);
                  // if (value) {
                  // } else {
                  //   setFieldValue("is_activated", false);
                  // }
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            {user.regional_uuid === null && (
              <div className="col-lg-4">
                <label htmlFor="organization_regional">Regional</label>
                <ReactSelect
                  name="organization_regional"
                  options={options.orgRegional.map(item => ({
                    label: item.name,
                    value: item.uuid
                  }))}
                  placeholder="Pilih Regional Lembaga..."
                  value={{
                    label: values.organization_regional_label,
                    value: values.organization_regional_uuid
                  }}
                  isClearable
                  onChange={e => {
                    const value = e && e.value;
                    const label = e && e.label;
                    setFieldValue("organization_regional_label", label);
                    setFieldValue("organization_regional_uuid", value);
                  }}
                />
              </div>
            )}
            <div className="col-lg-4">
              <label htmlFor="organization_category">Kategori</label>
              <AsyikSelect
                defaultOptions={options.orgCategory.map(({ name, uuid }) => ({
                  label: name,
                  value: uuid
                }))}
                loadOptions={genOptionLoaderDebounced(
                  inputValue =>
                    findOrganizationCategory({
                      pageNumber: 1,
                      pageSize: 10,
                      filter: {
                        name: inputValue
                      }
                    }),
                  ({ uuid, name }) => ({ label: name, value: uuid })
                )}
                value={
                  values.organization_category_uuid
                    ? {
                        label: values.organization_category_name,
                        value: values.organization_category_uuid
                      }
                    : null
                }
                placeholder="Pilih Kategori Lembaga..."
                onChange={selected => {
                  const { label = "", value = "" } = selected ?? {};

                  setFieldValue("organization_category_name", label);
                  setFieldValue("organization_category_uuid", value);
                }}
                isClearable
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
